import { render, staticRenderFns } from "./createAddEditEmployee.vue?vue&type=template&id=38c25d9d&scoped=true"
import script from "./createAddEditEmployee.vue?vue&type=script&lang=js"
export * from "./createAddEditEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c25d9d",
  null
  
)

export default component.exports